import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";
import { createId } from "@paralleldrive/cuid2";

// Schema
export const languageSchema = itemSchema.extend({
  name: z.string().min(1),
  description: z.string(),
  level: z.coerce.number().min(0).max(5).default(1),
});

export const minimalLanguageSchema = languageSchema.omit({
  id: true,
  visible: true,
});

// Type
export type Language = z.infer<typeof languageSchema>;
export type MinimalLanguage = z.infer<typeof minimalLanguageSchema>;

// Defaults
export const defaultLanguage: Language = {
  ...defaultItem,
  name: "",
  description: "",
  level: 1,
};

export const deminimalizeLanguage = (language: MinimalLanguage): Language => {
  return {
    ...defaultLanguage,
    ...language,
    id: createId(),
  };
};
